import { State, Action, StateContext, Selector } from '@ngxs/store';
import { PatchPayerList } from './payer.actions';
import { IInsuranceCompany } from '../../../core/modules/admin-modules/insurance-company/models/insurance-company.model';

interface PayerStateModel {
  payers: IInsuranceCompany[] | null;
}

@State<PayerStateModel>({
  name: 'payer',
  defaults: {
    payers: null
  }
})
export class PayerState {

  @Selector()
  static payers(state: PayerStateModel) {
    return state?.payers;
  }

  @Action(PatchPayerList)
  patchPayerList(ctx: StateContext<PayerStateModel>, action: PatchPayerList) {
    ctx.patchState({
      payers: action.payload
    });
  }
}